export default __webpack_public_path__ + "static/media/0x26f6cb841f9d4d72b68d7dcb6fdb5d6c832dd2a7.422b7a2f.webp";